import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";

import type {
  EquipmentPayloadType,
  EquipmentType,
} from "@/common/types/equipment";

export async function equipmentList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/equipment/list${queryString}`,
  );
}

export async function equipmentAdd(
  account_id: string,
  payload: EquipmentPayloadType,
) {
  return await clientAxios.post(
    `account/${account_id}/equipment/create`,
    payload,
  );
}

export async function equipmentGet(account_id: string, equipments_id: string) {
  return await clientAxios.get(
    `account/${account_id}/equipment/${equipments_id}/show`,
  );
}

export async function equipmentPatch(
  account_id: string,
  equipment_id: string,
  payload: Partial<EquipmentType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/equipment/${equipment_id}/patch`,
    {
      payload,
    },
  );
}

export async function equipmentPut(
  account_id: string,
  equipment_id: string,
  payload: EquipmentPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/equipment/${equipment_id}/edit`,
    payload,
  );
}

export async function equipmentDel(account_id: string, equipments_id: string) {
  return await clientAxios.del(
    `account/${account_id}/equipment/${equipments_id}/delete`,
  );
}

export async function equipmentUpload(account_id: string, payload: FileType) {
  return await clientAxios.post(
    `account/${account_id}/equipment/upload`,
    payload,
  );
}

export async function equipmentModelCSV(account_id: string) {
  return await clientAxios.get(`account/${account_id}/equipment/csv/model`);
}
